export default `
"Legumes"->"alfalfa","clover", "peas", "beans"
"Fruit"->"oranges","grapes","strawberries"
"Dairy"->"milk","butter","cheese","yogurt"
"Cereals"->"maize","wheat","rice"
"Seafood"->"fish","molluscs","crustaceans"
`